import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuth } from '@/hooks/useAuth';

export function useReports() {
  const { user } = useAuth();

  return {
    // Inventory Valuation
    getInventoryValuation: (params?: { location_id?: string; category_id?: string }) =>
      useQuery({
        queryKey: ['inventory-valuation', user?.hospital_id, params],
        queryFn: () => api.getInventoryValuation(params),
        enabled: !!user?.hospital_id,
      }),

    // Consumption Trends
    getConsumptionTrends: (params?: { start_date?: string; end_date?: string; item_id?: string; transaction_type?: string }) =>
      useQuery({
        queryKey: ['consumption-trends', user?.hospital_id, params],
        queryFn: () => api.getConsumptionTrends(params),
        enabled: !!user?.hospital_id,
      }),

    // Stock Movement Audit
    getStockMovementAudit: (params?: { item_id?: string; location_id?: string; transaction_type?: string; start_date?: string; end_date?: string; page?: number; page_size?: number }) =>
      useQuery({
        queryKey: ['stock-movement-audit', user?.hospital_id, params],
        queryFn: () => api.getStockMovementAudit(params),
        enabled: !!user?.hospital_id,
      }),

    // Purchase Analytics
    getPurchaseAnalytics: (params?: { start_date?: string; end_date?: string; vendor_id?: string }) =>
      useQuery({
        queryKey: ['purchase-analytics', user?.hospital_id, params],
        queryFn: () => api.getPurchaseAnalytics(params),
        enabled: !!user?.hospital_id,
      }),

    // Purchase Forecast
    getPurchaseForecast: (params?: { months?: number; category_id?: string; department_type?: string }) =>
      useQuery({
        queryKey: ['purchase-forecast', user?.hospital_id, params],
        queryFn: () => api.getPurchaseForecast(params),
        enabled: !!user?.hospital_id,
      }),
  };
}
